import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountComponent } from './account.component';
import {SharedModule} from "../shared/shared.module";
import {AppTranslateModule} from "../core/translate/translate.module";
import {ReactiveFormsModule} from "@angular/forms";
import {AccountRoutingModule, ROUTED_COMPONENTS} from "./account.routing.module";
import {AccountService} from "./account.service";
import {ApiKeyService} from "./api-key.service";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AppTranslateModule,
    ReactiveFormsModule,
    AccountRoutingModule
  ],
  providers:[AccountService, ApiKeyService],
  declarations: [AccountComponent, ROUTED_COMPONENTS]
})
export class AccountModule { }



// WEBPACK FOOTER //
// ./src/app/accounts/accounts.module.ts